<script setup>

</script>

<template>
    <div class="welcome-section text-center py-5 px-3">
        <h3>សូមស្វាគមន៍ <span class="text-green">ការចូលមកដល់គេហទំព័រ សេវាព័ត៌មានទីផ្សារកសិកម្ម</span></h3>
        <div class="small-hr-md my-1 d-inline-flex"/>
        <div class="d-flex justify-content-center">
            <p class="fs-20 px-2 px-md-5">គេហទំព័រនេះ ជាប្រភពធនធានគេហទំព័រមួយ
                ដែលផ្តល់នូវព័ត៌មានដ៏មានសារៈប្រយោជន៍ដើម្បីជួយកសិករ និងពាណិជ្ជករ ឱ្យកាន់តែទទួលបានជោគជ័យ
                នៅលើទីផ្សារកសិកម្ម កម្ពុជា។ នៅទីនេះ លោកអ្នកអាចរកបាននូវតម្លៃកសិផល
                និងអាចប្រើប្រាស់នូវប្រភពធនធានព័ត៌មានឯទៀត។</p>
        </div>
    </div>
</template>

<style scoped>

</style>
